import { Box } from "@mui/material";
import { EvaluationMetricTable } from "components/EvaluationMetric";
import { Modal } from "components/Modal";
import { FC } from "react";
import Markdown from "react-markdown";
import { CustomLabel } from "types/CustomLabel";
import { EvaluationMetric } from "types/evaluationMetric";
import { Requirement } from "types/requirement";

type SuccessRubricProps = {
  open: boolean;
  onClose: () => void;
  requirement: Requirement;
  customLabels?: CustomLabel[];
};

export const SuccessRubric: FC<SuccessRubricProps> = ({
  open,
  onClose,
  requirement,
  customLabels = [],
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={`Rubric of Success for ${requirement.name}`}
      size="medium"
    >
      <Box>
        <Markdown>{requirement.description}</Markdown>

        <Box>
          <EvaluationMetricTable
            requirement={requirement}
            evaluationMetrics={
              (requirement.evaluation_metrics as EvaluationMetric[]) || []
            }
            customLabels={customLabels}
          />
        </Box>
      </Box>
    </Modal>
  );
};
